import { Box } from "@mui/material";
import VerificationInput from "react-verification-input";

export default function Enable2FA({ data: code, setData: setCode }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <VerificationInput
        type="text"
        value={code.one_time_password}
        onChange={value => setCode({
          ...code,
          one_time_password: value,
        })}
        placeholder="."
        autoFocus
      />
    </Box>
  );
}
